export const translations = {
  codigo: {
    pt: "Código",
    en: "Code",
    de: "Code",
    es: "Código",
  },
  email: {
    pt: "E-mail",
    en: "E-mail",
    de: "E-mail",
    es: "Correo electrónico",
  },
  expiração: {
    pt: "Expiração",
    en: "Expiration",
    de: "Ablauf",
    es: "Expiración",
  },
  expirou: {
    pt: "Expirou",
    en: "Expired",
    de: "Abgelaufen",
    es: "Expiró",
  },
  diasRestantes: {
    pt: "dias restantes",
    en: "remaining days",
    de: "verbleibende Tage",
    es: "días restantes",
  },
  cancelar: {
    pt: "Cancelar",
    en: "Cancel",
    de: "kündiger",
    es: "Cancelar",
  },
  salvar: {
    pt: "Salvar",
    en: "Save",
    de: "Speichern",
    es: "Guardar",
  },
};
